const WinlosesTypes = {
    FETCH_START:    '[SERVERS] FETCH START',
    FETCH_SUCCESS:  '[SERVERS] FETCH SUCCESS',
    FETCH_FAILURE:  '[SERVERS] FETCH FAILURE'
};

export default WinlosesTypes;